/* eslint-disable import/first */
import React from 'react';

import { Icon } from '@chakra-ui/react';
import {
  MdBarChart,
  MdPerson,
  MdHome,
  MdLock,
  MdGroup,
  MdLibraryBooks,
  MdHistory,
  MdPayment,
} from 'react-icons/md';

// Admin Imports
import MainDashboard from 'views/admin/default';

import Profile from 'views/admin/profile';
import DataTables from 'views/admin/dataTables';
import RTL from 'views/admin/rtl';

// Auth Imports
import SignInCentered from 'views/auth/signIn';
import SignUpCentered from 'views/auth/signUp';
import { lazy } from 'react'; // eslint-disable-line import/first

const LazyKnowledgeBase = lazy(() => import('views/admin/knowledgeBase'));
const LazyAgents = lazy(() => import('views/admin/agents'));
const LazyNewAgent = lazy(() => import('views/admin/agents/NewAgent'));
const LazyAgentDetails = lazy(() => import('views/admin/agents/AgentDetails'));
const LazyConversations = lazy(() => import('views/admin/conversations'));
import { MdRecordVoiceOver, MdPeople } from 'react-icons/md';

const LazyPeopleDirectory = lazy(() => import('views/admin/peopleDirectory'));
const LazyTeams = lazy(() => import('views/admin/teams'));
const LazyJoinTeam = lazy(() => import('views/admin/teams/JoinTeam'));
const LazyDeclineTeam = lazy(() => import('views/admin/teams/DeclineTeam'));
const LazyGlobalTaskHistory = lazy(() => import('views/admin/taskHistory'));
const LazySubscriptions = lazy(() => import('views/admin/subscriptions'));
const LazyMeeting = lazy(() => import('views/admin/meeting'));
const LazyMeetingTranscript = lazy(() => import('views/admin/meeting/transcript'));

const routes = [
  {
    name: 'Dashboard',
    layout: '/admin',
    path: '/default',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <MainDashboard />,
  },
  {
    name: 'Agents',
    category: true,
    items: [
      {
        name: 'All Agents',
        layout: '/admin',
        path: '/agents',
        icon: <Icon as={MdGroup} width="20px" height="20px" color="inherit" />,
        component: <LazyAgents />,
      }
    ]
  },
  {
    name: 'Conversations',
    layout: '/admin',
    path: '/conversations',
    icon: <Icon as={MdRecordVoiceOver} width="20px" height="20px" color="inherit" />,
    component: <LazyConversations />,
  },
  {
    name: 'Task History',
    layout: '/admin',
    path: '/task-history',
    icon: <Icon as={MdHistory} width="20px" height="20px" color="inherit" />,
    component: <LazyGlobalTaskHistory />,
  },
  {
    name: 'Teams',
    layout: '/admin',
    path: '/teams',
    icon: <Icon as={MdGroup} width="20px" height="20px" color="inherit" />,
    component: <LazyTeams />,
  },
  {
    name: 'Join Team',
    layout: '/admin',
    path: '/teams/join',
    component: <LazyJoinTeam />,
    hideFromSidebar: true,
  },
  {
    name: 'Decline Team',
    layout: '/admin',
    path: '/teams/decline',
    component: <LazyDeclineTeam />,
    hideFromSidebar: true,
  },
  {
    name: 'People Directory',
    layout: '/admin',
    path: '/people-directory',
    icon: <Icon as={MdPeople} width="20px" height="20px" color="inherit" />,
    component: <LazyPeopleDirectory />,
  },
    {
    name: 'Knowledge Base',
    layout: '/admin',
    path: '/knowledge-base',
    icon: <Icon as={MdLibraryBooks} width="20px" height="20px" color="inherit" />,
    component: <LazyKnowledgeBase />,
  },
  {
    name: 'New Agent',
    layout: '/admin',
    path: '/agents/new',
    component: <LazyNewAgent />,
    hideFromSidebar: true,
  },
  {
    name: 'Agent Details',
    layout: '/admin',
    path: '/agents/:agentId',
    component: <LazyAgentDetails />,
    hideFromSidebar: true,
  },
  {
    name: 'Meeting',
    layout: '/admin',
    path: '/conversations/:conversationId',
    component: <LazyMeeting />,
    hideFromSidebar: true,
  },
  {
    name: 'Meeting Room',
    layout: '/admin',
    path: '/conversations/:conversationId/:roomType',
    component: <LazyMeeting />,
    hideFromSidebar: true,
  },
  {
    name: 'Meeting Transcript',
    layout: '/admin',
    path: '/conversations/:conversationId/transcript',
    component: <LazyMeetingTranscript />,
    hideFromSidebar: true,
  },
  {
    name: 'Subscriptions',
    layout: '/admin',
    path: '/subscriptions',
    icon: <Icon as={MdPayment} width="20px" height="20px" color="inherit" />,
    component: <LazySubscriptions />,
    hideFromSidebar: true,
  },

  {
    name: 'Data Tables',
    layout: '/admin',
    icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit" />,
    path: '/data-tables',
    component: <DataTables />,
    hideFromSidebar: true,
  },
  {
    name: 'Profile',
    layout: '/admin',
    path: '/profile',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: <Profile />,
    hideFromSidebar: true,
  },
  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <SignInCentered />,
    hideFromSidebar: true,
  },
  {
    name: 'Sign Up',
    layout: '/auth',
    path: '/sign-up',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <SignUpCentered />,
    hideFromSidebar: true,
  },
  {
    name: 'RTL Admin',
    layout: '/rtl',
    path: '/rtl-default',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <RTL />,
    hideFromSidebar: true,
  },
];

export default routes;
